export default __webpack_public_path__ + "static/media/C7.9ff11867.png";